import { useState, useEffect, useCallback, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useExameNecroscopicoService } from 'hooks/useExameNecroscopicoService'
import { useTipoExameService } from 'hooks/useTipoExameService'

export const useFormConclusao = ({ exameNecroscopico, form }) => {
  const exameNecroscopicoService = useExameNecroscopicoService()
  const tipoExameService = useTipoExameService()
  const options = useSelector((state) => state.options)

  const [initialValue, setInitialValue] = useState('')
  const [tiposExames, setTiposExames] = useState(null)
  const [processandoTiposExames, setProcessandoTiposExames] = useState(false)
  const editorRef = useRef(null)

  const fetchTiposExames = useCallback(async () => {
    try {
      const response = await tipoExameService.listarTiposExamesAsync(setProcessandoTiposExames)
      setTiposExames(response)
    } catch (error) {
      console.error('Error fetching tipos exames:', error)
    }
  }, []) // Excluded service instance to prevent infinite render loops

  useEffect(() => {
    if (!tiposExames) {
      fetchTiposExames()
    }
  }, [fetchTiposExames, tiposExames])

  const handleConclusaoChange = useCallback((e) => {
    if (editorRef.current) {
      form.setFormState((prev) => ({
        ...prev,
        values: {
          ...prev.values,
          conclusao: e.target.getContent(),
        },
      }))
    }
  }, [form.setFormState])

  useEffect(() => {
    if (exameNecroscopico?.id) {
      form.setFormState((prev) => ({
        ...prev,
        values: {
          ...prev.values,
          examesSubsidiarios: exameNecroscopico.exSubs,
          causaMorte: exameNecroscopico.causMort,
          causaMorteTextoLivre: exameNecroscopico.causaMorteTextoLivre,
        },
      }))
    }
  }, [exameNecroscopico])

  useEffect(() => {
    if (!options.causasMorte) {
      exameNecroscopicoService.listarCausasMorteGlobal()
    }
  }, [options.causasMorte]) // Excluded service instance to prevent loops

  useEffect(() => {
    if (exameNecroscopico?.id) {
      setInitialValue(exameNecroscopico.conclusao || 'Face aos exames realizado sobre o cadáver, é possível concluir que ')
    }
  }, [exameNecroscopico?.id])

  useEffect(() => {
    form.setFormState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        exSubs: exameNecroscopico?.exSubs,
        causaMorte: exameNecroscopico?.causMort,
        conclusao: initialValue,
        causaMorteTextoLivre: exameNecroscopico?.causaMorteTextoLivre,
      },
    }))
  }, [initialValue])

  return {
    tiposExames,
    processandoTiposExames,
    editorRef,
    options,
    initialValue,
    handleConclusaoChange,
  }
}
